import { dispatcher } from "@quest/base-core";
import { TopLogoController } from "@quest/murka-games-behavior-leopard/dist/Game/TopLogo/TopLogoController";

import { eventDispatchers } from "../Constants/EventDispatchers";

export class TopLogoControllerGame extends TopLogoController {
  // Overrided to subscribe game end events
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.HIDE_TOP_LOGO_ON_SELECTION_SCREEN, this.hideTopLogo, this);
    dispatcher.on(eventDispatchers.SHOW_TOP_LOGO_ON_SELECTION_SCREEN, this.showTopLogo, this);
  }

  // Overrided to unsubscribe game end events
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.HIDE_TOP_LOGO_ON_SELECTION_SCREEN, this.hideTopLogo, this);
    dispatcher.off(eventDispatchers.SHOW_TOP_LOGO_ON_SELECTION_SCREEN, this.showTopLogo, this);
  }

  // Add to hide portrait logo on bonus wheel feature
  private hideTopLogo(): void {
    // this.view.getContainerByID("topLogoContainer").visible = false;
  }

  // Add to show portrait logo after bonus wheel
  private showTopLogo(): void {
    // this.view.getContainerByID("topLogoContainer").visible = true;
  }
}
